import React from "react"
import { useForm } from "react-hook-form"
import { InviteKey } from "popopo-msg"

type InviteForms = {
  inviteKey: string
}

export const InviteForm = (props: {
  onSubmitJoin: (request: InviteKey) => Promise<void>,
  onSubmitCheck?: (request: InviteKey) => Promise<void>,
}) => {
  const form = useForm<InviteForms>({
    mode: "onBlur",
    defaultValues: {
      inviteKey: "",
    },
  })
  const { isSubmitting } = form.formState

  const onSubmit = async (value: InviteForms) => {
    props.onSubmitCheck && await props.onSubmitCheck(InviteKey(value.inviteKey))
  }

  const onSubmitJoin = async (value: InviteForms) => {
    await props.onSubmitJoin(InviteKey(value.inviteKey))
  }

  return (
    <>
      <form className="d-flex flex-column gap-3 w-100">
        <div className="form-floating">
          <input className="form-control" {...form.register("inviteKey")} disabled={isSubmitting} />
          <label>Invite key</label>
        </div>

        { props.onSubmitCheck &&
          <button type="button" className="btn btn-primary form-control" onClick={form.handleSubmit(onSubmit)}>
            Inviteの確認
          </button>
        }
        <button type="button" className="btn btn-warning form-control" onClick={form.handleSubmit(onSubmitJoin)}>
          Inviteを受けいれる
        </button>
      </form>
    </>
  )
}
